import { Navigate } from "react-router";
import { LoginScreen, useAuthState } from "visumo-data-agent-web-shared";

import { HelpIcon } from "../help/HelpIcon";

export function LoginPage() {
  const state = useAuthState();
  if (state.status === "authenticated") {
    return <Navigate to="/" replace />;
  }
  return (
    <LoginScreen
      appName="visumo 管理画面"
      description="visumo のアカウントでログインします。"
      returnTo="/tenants"
      extra={<HelpIcon slug="getting-started/login" />}
    />
  );
}
